import { useNavigationContainerRef } from "@-/com.npmjs.expo-router";
import { RozeniteOverlay } from "@-/com.npmjs.rozenite__overlay-plugin";
import { useReactNavigationDevTools } from "@-/com.npmjs.rozenite__react-navigation-plugin";
import type { ReactNode } from "react";
import type { RootLayoutNavigationDevtoolsGate } from "#use-root-layout-navigation-devtools-gate";

export type RootLayoutNavigationDevtoolsProps = {
  gate: RootLayoutNavigationDevtoolsGate;
  navigationRef: ReturnType<typeof useNavigationContainerRef>;
};

/**
 * Navigation Rozenite plugins plus the on-device overlay. Remains a component because it renders
 * {@link RozeniteOverlay}. It mounts only once its gate exists, so the devtools hooks below are
 * never added to an already-mounted component.
 */
export function RootLayoutNavigationDevtools({
  navigationRef,
}: RootLayoutNavigationDevtoolsProps): ReactNode {
  useReactNavigationDevTools({
    // @ts-expect-error: expo-router uses an incompatible NavigationContainerRef brands.
    ref: navigationRef,
  });

  return <RozeniteOverlay />;
}
